// extracted by mini-css-extract-plugin
export default {"loadtext":"Loading_loadtext__gqvBU"};